module.exports = __webpack_public_path__ + "img/204.6ea75890.jpg";